<template>
  <div>
    <v-container
      id="regular-tables"
      fluid
      tag="section"
    >
        <!-- v-if="this.$route.params.convocatoria" -->
      <v-row
        class="pa-4"
      >
        <v-col
          class="py-0 my-0"
        />
        <v-btn
          class="ma-2"
          outlined
          color="indigo"
          @click="volverDeContactosEntidadesTecnicas"
        >
        <v-icon dark>
              mdi-arrow-left
            </v-icon>
          Regresar
        </v-btn>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="contactos"
        item-key="name"
        class="elevation-1"
        :search="search"
      >
        <template v-slot:top>
          <v-row
            class="pa-4"
          >
            <v-col
              class="py-0 my-0"
            />
            <v-col
              class="py-0 my-0"
            >
              <v-text-field
                v-model="search"
                label="Buscar contactos..."
                outlined
              />
            </v-col>
          </v-row>
        </template>

        <template v-slot:[`item.accions`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                @click="editarContacto(item)"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip 
            v-if="isAdmin"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click="dialogDelete(item)"
              >
                mdi-trash-can-outline
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
          <!-- <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2 ml-2"
                v-bind="attrs"
                @click="$router.push({ name: 'contactos de entidades tecnicas', params: { entidadId: item.id } })"
                v-on="on"
              >
                mdi-eye
              </v-icon>
            </template>
            <span>Contactos</span>
          </v-tooltip> -->
        </template>
      </v-data-table>
    </v-container>

    <v-btn
      class="mx-2"
      right
      absolute
      fab
      dark
      color="indigo"
      @click="newContacto"
    >
      <v-icon dark>
        mdi-plus
      </v-icon>
    </v-btn>
    <new-contactos-cliente
      ref="newContactoCliente"
      :clienteId="cliente_id"
      @onCreate="onCreate"
    />
    <dialog-personalizado
      ref="dialogContacto"
      @onDialog="onDialog"
    />
  </div>
</template>

<script>
  // import firebase from 'firebase'
  import NewContactosCliente from './components/NewContactoCliente.vue'
  import DialogPersonalizado from '../components/Dialog.vue'

  // const db = firebase.firestore()

  export default {
    components: {
      NewContactosCliente,
      DialogPersonalizado,
    },
    data () {
      return {
        headers: [
          { text: 'Nombre de contacto', value: 'nombre' },
          { text: 'Telefono Personal', value: 'telefono' },
          { text: 'Teléfono Corporativo', value: 'telefono2' },
          { text: 'Dirección de oficina', value: 'direccion' },
          { text: 'Email Personal', value: 'email' },
          { text: 'Email Corporativo', value: 'email2' },
          { text: 'Empresa', value: 'empresa' },
          { text: 'Cargo', value: 'cargo' },
          { text: 'Accions', value: 'accions' },
        ],
        contactos: [],
        search: '',
        cliente_id: undefined
      }
    },
    computed: {
      isAdmin () {
        return JSON.parse(localStorage.userAuth).perfil === 'Administrador'
    },
    },
    mounted () {
      this.existeClienteId()
    },
    methods: {
      existeClienteId () {
        if (!this.$route.params.cliente_id) {
          this.$router.push({ name: 'clientes' })
        } else {
          this.getContactoCliente()
          this.cliente_id = this.$route.params.cliente_id
        }
      },
      newContacto () {
        this.$refs.newContactoCliente.open()
      },
      async getContactoCliente () {
        this.contactos = []
        const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/cliente/contacto/' + this.$route.params.cliente_id)

        const data = await response.json()
        this.contactos = data.data
      },
      onCreate () {
        this.getContactoCliente()
      },
      editarContacto (item) {
        this.$refs.newContactoCliente.open(item)
      },
      dialogDelete (item) {
        this.$refs.dialogContacto.open('Eliminar Contacto', '¿Esta seguro de eliminar el contacto seleccionado?', item)
      },
      onDialog (data) {
        this.eliminarContacto(data)
      },
      async eliminarContacto (contacto) {
        const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/cliente/contacto/' + contacto.id, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json'
          }
        })
        const data = await response.json()
        if (data.success) {}

        this.$refs.dialogContacto.close()
        this.getContactoCliente()
      },
      volverDeContactosEntidadesTecnicas () {
        // this.$router.push({ name: 'Entidades Tecnicas' })
        if (this.$route.params.isConvocatoria) {
          this.$router.push({ name: 'Entidades de una convocatoria', params: { convocatoria: this.$route.params.convocatoria } })
        } else {
          this.$router.push({ name: 'clientes' })
        }
      }
    },
  }
</script>

<style>

</style>
